import { PREFERENCE_MAXIMUM_LIMIT } from "@repo/shared";

export const T = {
  en_GB: {
    maxPerPreference: "Maximum per preference (%)",
    maxTotalPreferences: "Maximum for all preferences (%)",
    wholeNumber: `Enter whole numbers between 0 and ${PREFERENCE_MAXIMUM_LIMIT}.`,
    perAboveTotal: "The maximum per preference cannot be above the maximum for all preferences.",
  },
  nb_NO: {
    maxPerPreference: "Maksimum per preferanse (%)",
    maxTotalPreferences: "Maksimum for alle preferanser (%)",
    wholeNumber: `Skriv inn hele tall mellom 0 og ${PREFERENCE_MAXIMUM_LIMIT}.`,
    perAboveTotal:
      "Maksimum per preferanse kan ikke være høyere enn maksimum for alle preferanser.",
  },
} as const;
